import { RefundPaymentResponse } from "../../../infrastructure/models/transport/response/RefundPaymentResponse"
import { ApiRoutes } from "../routes"
import { Logger } from "../logger"
import { HttpService } from "../http"
import { SessionService } from "../session"
import { container } from "../../../infrastructure/container"
import { LoginError } from "../../../infrastructure/models/login"
import { RefundPaymentRequest } from "@infrastructure/models/transport/request/RefundBodyRequest"

export interface RefundService {
    /**  To Refund Amount */
    refundPayment(payload: RefundPaymentRequest): Promise<RefundPaymentResponse>

    /** To fetch refund status by merchantRefundId */
    getRefundStatus(merchantRefundId: string): Promise<any>
}

export class AppRefundService implements RefundService {
    /**
     * Initializes the login service with the HTTP service instance.
     * @param httpService - The HTTP service to send API requests.
     */
    private httpService = container.resolve<HttpService>("httpService")
    private sessionService = container.resolve<SessionService>("sessionService")
    private logger = container.resolve<Logger>("logger")

    async refundPayment(payload: RefundPaymentRequest): Promise<RefundPaymentResponse> {
        const response = await this.httpService.post<RefundPaymentRequest, RefundPaymentResponse, LoginError>(
            ApiRoutes.REFUND_AMOUNT,
            payload
        )
        return response
    }

    async getRefundStatus(merchantRefundId: string): Promise<any> {
        const response = await this.httpService.get<any, LoginError>(
            `${ApiRoutes.REFUND_AMOUNT_STATUS}/${merchantRefundId}`
        )
        return response
    }
}